import { defineMessages } from 'react-intl';

export default defineMessages({
  ConfirmationMessageHeader: {
    id: 'Apply.Confirmation.Header',
    defaultMessage: 'Your Application Has Been Received',
  },
  ConfirmationMessageSubHeader: {
    id: 'Apply.Confirmation.SubHeader',
    defaultMessage: "What's Next",
  },
  ConfirmationMessage: {
    id: 'Apply.Confirmation.Message',
    defaultMessage:
      'Check your email to create your Tesla Connect account. With Tesla Connect, view the status of your application and manage your personal information.',
  },
});
